import { ShopThemeKey } from 'types/ShopTheme';

const cssVar = (key: ShopThemeKey): `var(--${ShopThemeKey})` => `var(--${key})`;

export default cssVar;
